// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
}

.font-size-1 {
  font-size: 1px !important;
}

.font-size-2 {
  font-size: 2px !important;
}

.font-size-3 {
  font-size: 3px !important;
}

.font-size-4 {
  font-size: 4px !important;
}

.font-size-5 {
  font-size: 5px !important;
}

.font-size-6 {
  font-size: 6px !important;
}

.font-size-7 {
  font-size: 7px !important;
}

.font-size-8 {
  font-size: 8px !important;
}

.font-size-9 {
  font-size: 9px !important;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-19 {
  font-size: 19px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-21 {
  font-size: 21px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-23 {
  font-size: 23px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.font-size-25 {
  font-size: 25px !important;
}

.font-size-26 {
  font-size: 26px !important;
}

.font-size-27 {
  font-size: 27px !important;
}

.font-size-28 {
  font-size: 28px !important;
}

.font-size-29 {
  font-size: 29px !important;
}

.font-size-30 {
  font-size: 30px !important;
}

.font-size-31 {
  font-size: 31px !important;
}

.font-size-32 {
  font-size: 32px !important;
}

.font-size-33 {
  font-size: 33px !important;
}

.font-size-34 {
  font-size: 34px !important;
}

.font-size-35 {
  font-size: 35px !important;
}

.font-size-36 {
  font-size: 36px !important;
}

.font-size-37 {
  font-size: 37px !important;
}

.font-size-38 {
  font-size: 38px !important;
}

.font-size-39 {
  font-size: 39px !important;
}

.font-size-40 {
  font-size: 40px !important;
}

.font-size-41 {
  font-size: 41px !important;
}

.font-size-42 {
  font-size: 42px !important;
}

.font-size-43 {
  font-size: 43px !important;
}

.font-size-44 {
  font-size: 44px !important;
}

.font-size-45 {
  font-size: 45px !important;
}

.font-size-46 {
  font-size: 46px !important;
}

.font-size-47 {
  font-size: 47px !important;
}

.font-size-48 {
  font-size: 48px !important;
}

.font-size-49 {
  font-size: 49px !important;
}

.font-size-50 {
  font-size: 50px !important;
}

.font-size-51 {
  font-size: 51px !important;
}

.font-size-52 {
  font-size: 52px !important;
}

.font-size-53 {
  font-size: 53px !important;
}

.font-size-54 {
  font-size: 54px !important;
}

.font-size-55 {
  font-size: 55px !important;
}

.font-size-56 {
  font-size: 56px !important;
}

.font-size-57 {
  font-size: 57px !important;
}

.font-size-58 {
  font-size: 58px !important;
}

.font-size-59 {
  font-size: 59px !important;
}

.font-size-60 {
  font-size: 60px !important;
}

.font-size-61 {
  font-size: 61px !important;
}

.font-size-62 {
  font-size: 62px !important;
}

.font-size-63 {
  font-size: 63px !important;
}

.font-size-64 {
  font-size: 64px !important;
}

.font-size-65 {
  font-size: 65px !important;
}

.font-size-66 {
  font-size: 66px !important;
}

.font-size-67 {
  font-size: 67px !important;
}

.font-size-68 {
  font-size: 68px !important;
}

.font-size-69 {
  font-size: 69px !important;
}

.font-size-70 {
  font-size: 70px !important;
}

.font-size-71 {
  font-size: 71px !important;
}

.font-size-72 {
  font-size: 72px !important;
}

.font-size-73 {
  font-size: 73px !important;
}

.font-size-74 {
  font-size: 74px !important;
}

.font-size-75 {
  font-size: 75px !important;
}

.font-size-76 {
  font-size: 76px !important;
}

.font-size-77 {
  font-size: 77px !important;
}

.font-size-78 {
  font-size: 78px !important;
}

.font-size-79 {
  font-size: 79px !important;
}

.font-size-80 {
  font-size: 80px !important;
}

.font-size-81 {
  font-size: 81px !important;
}

.font-size-82 {
  font-size: 82px !important;
}

.font-size-83 {
  font-size: 83px !important;
}

.font-size-84 {
  font-size: 84px !important;
}

.font-size-85 {
  font-size: 85px !important;
}

.font-size-86 {
  font-size: 86px !important;
}

.font-size-87 {
  font-size: 87px !important;
}

.font-size-88 {
  font-size: 88px !important;
}

.font-size-89 {
  font-size: 89px !important;
}

.font-size-90 {
  font-size: 90px !important;
}

.font-size-91 {
  font-size: 91px !important;
}

.font-size-92 {
  font-size: 92px !important;
}

.font-size-93 {
  font-size: 93px !important;
}

.font-size-94 {
  font-size: 94px !important;
}

.font-size-95 {
  font-size: 95px !important;
}

.font-size-96 {
  font-size: 96px !important;
}

.font-size-97 {
  font-size: 97px !important;
}

.font-size-98 {
  font-size: 98px !important;
}

.font-size-99 {
  font-size: 99px !important;
}

.font-size-100 {
  font-size: 100px !important;
}

body {
  margin: 0;
  font-family: "roboto" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: hsl(0, 0%, 92%) !important;
  color: hsl(217, 24%, 17%) !important;
}

a {
  color: hsl(240, 91%, 69%);
}
a:hover, a:focus {
  color: hsl(240, 91%, 69%);
}
a.no-underline {
  text-decoration: none;
}

.cursor-pointer {
  cursor: pointer;
}

#dashBody {
  padding: 0;
  border: 0px;
}

.HLinks:hover {
  background: #F8F8F8;
}

.BOXXX {
  background: white;
  font-size: 16px;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.BOXXX span {
  color: #4C4F53;
  padding: 2px 0px;
  white-space: nowrap;
  position: relative;
}
.BOXXX span:before {
  background-color: #4D4DF6;
  bottom: -11.9px;
  content: "";
  height: 2px;
  left: 0px;
  opacity: 0;
  position: absolute;
  right: 0px;
  transform-origin: left center;
  transform: scaleX(0);
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  visibility: hidden;
  width: auto;
}

.SBOX span {
  color: hsl(233, 100%, 57%);
}
.SBOX span:before {
  visibility: visible;
  opacity: 1 !important;
}

.selected {
  border-radius: 18px;
}

.loader {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-weight: 900;
  font-size: 24px;
  line-height: 90px;
}
.loader__title {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-45%, 0%);
}
.loader .linear_progress {
  position: absolute;
  top: 58%;
  left: 50%;
  transform: translate(-50%, 0%);
  background-image: linear-gradient(89.91deg, rgba(220, 34, 255, 0.5) 12.07%, rgba(57, 161, 244, 0.5) 89.16%);
  margin-left: 1em;
  width: 414px;
}
.loader .linear_progress .MuiLinearProgress-bar {
  background-color: #fff;
  width: 1.5em;
}

.dashboard {
  flex-grow: 1;
}
.dashboard__body {
  padding: 4rem;
  position: relative;
}
.dashboard__body .setting_btn p {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
}
.dashboard__body .setting_btn p a {
  color: hsl(233, 100%, 57%);
  text-decoration: none;
}
.dashboard__body__success {
  padding: 7px 11px 9px 10px;
  width: fit-content;
  border-radius: 10px;
  font-size: 12px;
  background-color: hsl(0, 0%, 92%);
  position: fixed;
  bottom: 1.5em;
  left: 2.5em;
}
.dashboard__body__success .header__msg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.dashboard__body__success.success {
  background-color: hsla(113, 49%, 55%, 0.34);
}
.dashboard__body__success .success-msg {
  color: hsl(217, 24%, 17%);
  margin-left: 1em;
  margin-right: 1em;
}
.dashboard__body__success .success-close {
  color: hsl(214, 4%, 39%);
  text-decoration: underline;
  cursor: pointer;
}
.dashboard__body__list .tab__header {
  display: flex;
}
.dashboard__body__list .tab__header .MuiTabs-root {
  min-height: fit-content;
}
.dashboard__body__list .tab__header .MuiTabs-root .MuiTabs-flexContainer {
  height: 38px;
}
.dashboard__body__list .tab__header .MuiButtonBase-root {
  padding: 0;
  margin-right: 0.75em;
}
.dashboard__body__list .tab__header__item {
  padding: 0.6rem 1.25rem;
  background-color: hsl(0, 0%, 100%);
  border-radius: 4px;
  color: hsl(237, 46%, 75%);
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.25px;
  display: flex;
  min-width: 120px;
  justify-content: center;
  align-items: center;
}
.dashboard__body__list .tab__header__item.active {
  color: hsl(237, 69%, 40%);
  background-color: hsla(240, 22%, 95%, 0.22);
}
.dashboard__body__list .tab__header__icon {
  margin-right: 5px;
}
.dashboard__body__list .tab__body .MuiBox-root {
  padding: 0;
}
.dashboard__body__header {
  margin-bottom: 25px;
}
.dashboard__body__header .new__gate {
  background-color: hsl(233, 100%, 57%) !important;
  border-radius: 5px;
  box-shadow: none;
  font-weight: 400;
  font-size: 12px;
  text-transform: none;
  padding: 7px 44px;
  font-family: "Roboto";
}
.dashboard__body__header-dropdown .MuiSelectUnstyled-root {
  color: #4C4F53;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.25px;
  border: 1px solid #BABCBE;
  padding: 8px 13px;
  border-radius: 5px;
  min-width: 172px;
}
.dashboard__body__header-dropdown .MuiSelectUnstyled-root::after {
  font-size: 20px;
  line-height: 0.9;
}
.dashboard__body__header-dropdown .MuiSelectUnstyled-root.Mui-expanded {
  border-radius: 5px 5px 0 0;
}
.dashboard__body__header-dropdown .MuiSelectUnstyled-root.Mui-expanded::after {
  font-size: 28px !important;
  line-height: 0.5;
  float: right;
}
.dashboard__body__header-dropdown .MuiSelectUnstyled-popper .MuiSelectUnstyled-listbox {
  margin-top: 0;
  border-radius: 0 0 4px 4px;
  border: 1px solid #BABCBE;
  min-width: 172px;
}
.dashboard__body__header-dropdown .MuiSelectUnstyled-popper .MuiSelectUnstyled-listbox .MuiOptionUnstyled-root {
  border-radius: 0;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.25px;
  color: #4C4F53;
  cursor: pointer;
}
.dashboard__body__header-dropdown .MuiSelectUnstyled-popper .MuiSelectUnstyled-listbox .MuiOptionUnstyled-root[aria-disabled=true] {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  color: #C4C4C4;
}
.dashboard__body__header-dropdown .MuiSelectUnstyled-popper .MuiSelectUnstyled-listbox .MuiOptionUnstyled-root:not(:last-child) {
  border-bottom: 1px solid hsla(0, 0%, 92%, 0.69);
}
.dashboard__body__header-dropdown .MuiSelectUnstyled-popper .MuiSelectUnstyled-listbox .MuiOptionUnstyled-root.Mui-selected {
  background-color: hsla(234, 95%, 92%, 0.37);
  color: hsl(214, 4%, 31%);
  border-radius: 0;
  display: none;
}
.dashboard__body__header-btn {
  background-color: #1F27AC;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 3px 5px rgba(0, 0, 0, 0.2);
  border: none;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.25px;
  padding-left: 2rem;
  padding-right: 2rem;
}

.create__gate {
  text-align: center;
}
.create__gate__title-text {
  font-weight: 500;
  font-size: 20px;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: hsl(214, 4%, 31%);
}
.create__gate__body {
  padding-top: 1px;
}
.create__gate__body .input {
  background-color: #fff;
  border: none;
  width: 100%;
  padding: 0.5em 1em;
  border-radius: 10px;
  font-size: 14px;
}
.create__gate__body .input:focus-within {
  box-shadow: 0 0 0.05rem 0.05rem hsl(237, 46%, 75%);
}
.create__gate__body .input .MuiInput-input {
  padding-bottom: 0 !important;
  font-size: 14px;
  font-weight: 400;
}
.create__gate__body .input .MuiInput-input::placeholder {
  opacity: 1 !important;
}
.create__gate__body__label {
  margin: 0.5em;
  padding-left: 1em;
  font-size: 10px;
  color: rgb(0, 0, 0);
}
.create__gate__body__label.char {
  margin-bottom: 22px;
  display: inline-block;
}
.create__gate__body__label.char .error-display, .create__gate__body__label.char.error-display {
  color: hsl(5, 100%, 69%);
  font-size: 12px;
}
.create__gate__body__label.number {
  margin: 0;
  display: inline-block;
}
.create__gate__body__label.number.error-display {
  color: hsl(5, 100%, 69%);
  font-size: 12px;
}
.create__gate__body__footer {
  display: flex;
  justify-content: center;
}
.create__gate__body__footer .update__btn {
  background-color: hsl(233, 100%, 57%);
  padding: 4px 29px;
  text-transform: capitalize;
  letter-spacing: 0.25px !important;
  box-shadow: none;
  border-radius: 5px;
  font-weight: 600;
  font-size: 14px;
}
.create__gate__body .error {
  box-shadow: 0 0 0.05rem 0.05rem hsl(5, 100%, 69%);
}

.dashboard__success__message .dashboard__body__success {
  width: 322px;
  word-break: inherit;
  background-color: hsl(217, 24%, 17%);
  border-radius: 0;
  border-left: 4px solid #00B481;
  box-shadow: 0px 4px 4px rgba(196, 196, 196, 0.57);
  z-index: 1400;
}
.dashboard__success__message .dashboard__body__success .header__msg .success_icon_msg {
  font-weight: 700;
  font-size: 12px;
  color: #FDFDFD;
  letter-spacing: 0.15px;
}
.dashboard__success__message .dashboard__body__success .header__msg .success-close {
  font-weight: 400;
  font-size: 12px;
  color: #FDFDFD;
  letter-spacing: 0.15px;
}
.dashboard__success__message .dashboard__body__success .success-msg {
  margin: 0;
  font-weight: 300;
  font-size: 12px;
  color: #FDFDFD;
  letter-spacing: 0.15px;
  margin-bottom: 13px;
  overflow: hidden;
}

.table__wrongUrl__container .gates__list__body-table.wrongUrl .body__header.wrongUrl .gates__list__body-table-header.wrongUrl {
  width: 11%;
}
.table__wrongUrl__container .gates__list__body-table.wrongUrl .body__header.wrongUrl .gates__list__body-table-header.wrongUrl:first-child {
  width: 50%;
}
.table__wrongUrl__container .gates__list__body-table.wrongUrl .table__body.wrongUrl tr {
  background-color: hsl(0, 0%, 100%);
}
.table__wrongUrl__container .gates__list__body-table.wrongUrl .table__body.wrongUrl tr th, .table__wrongUrl__container .gates__list__body-table.wrongUrl .table__body.wrongUrl tr a {
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: hsl(5, 100%, 69%);
}
.table__wrongUrl__container .gates__list__body-table.wrongUrl .table__body.wrongUrl tr th a, .table__wrongUrl__container .gates__list__body-table.wrongUrl .table__body.wrongUrl tr a a {
  text-decoration: underline;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/components/gates/gates.scss"],"names":[],"mappings":"AAyDA;;EAEE,YAAA;ACvDF;;AD6DE;EACI,yBAAA;AC1DN;;ADyDE;EACI,yBAAA;ACtDN;;ADqDE;EACI,yBAAA;AClDN;;ADiDE;EACI,yBAAA;AC9CN;;AD6CE;EACI,yBAAA;AC1CN;;ADyCE;EACI,yBAAA;ACtCN;;ADqCE;EACI,yBAAA;AClCN;;ADiCE;EACI,yBAAA;AC9BN;;AD6BE;EACI,yBAAA;AC1BN;;ADyBE;EACI,0BAAA;ACtBN;;ADqBE;EACI,0BAAA;AClBN;;ADiBE;EACI,0BAAA;ACdN;;ADaE;EACI,0BAAA;ACVN;;ADSE;EACI,0BAAA;ACNN;;ADKE;EACI,0BAAA;ACFN;;ADCE;EACI,0BAAA;ACEN;;ADHE;EACI,0BAAA;ACMN;;ADPE;EACI,0BAAA;ACUN;;ADXE;EACI,0BAAA;ACcN;;ADfE;EACI,0BAAA;ACkBN;;ADnBE;EACI,0BAAA;ACsBN;;ADvBE;EACI,0BAAA;AC0BN;;AD3BE;EACI,0BAAA;AC8BN;;AD/BE;EACI,0BAAA;ACkCN;;ADnCE;EACI,0BAAA;ACsCN;;ADvCE;EACI,0BAAA;AC0CN;;AD3CE;EACI,0BAAA;AC8CN;;AD/CE;EACI,0BAAA;ACkDN;;ADnDE;EACI,0BAAA;ACsDN;;ADvDE;EACI,0BAAA;AC0DN;;AD3DE;EACI,0BAAA;AC8DN;;AD/DE;EACI,0BAAA;ACkEN;;ADnEE;EACI,0BAAA;ACsEN;;ADvEE;EACI,0BAAA;AC0EN;;AD3EE;EACI,0BAAA;AC8EN;;AD/EE;EACI,0BAAA;ACkFN;;ADnFE;EACI,0BAAA;ACsFN;;ADvFE;EACI,0BAAA;AC0FN;;AD3FE;EACI,0BAAA;AC8FN;;AD/FE;EACI,0BAAA;ACkGN;;ADnGE;EACI,0BAAA;ACsGN;;ADvGE;EACI,0BAAA;AC0GN;;AD3GE;EACI,0BAAA;AC8GN;;AD/GE;EACI,0BAAA;ACkHN;;ADnHE;EACI,0BAAA;ACsHN;;ADvHE;EACI,0BAAA;AC0HN;;AD3HE;EACI,0BAAA;AC8HN;;AD/HE;EACI,0BAAA;ACkIN;;ADnIE;EACI,0BAAA;ACsIN;;ADvIE;EACI,0BAAA;AC0IN;;AD3IE;EACI,0BAAA;AC8IN;;AD/IE;EACI,0BAAA;ACkJN;;ADnJE;EACI,0BAAA;ACsJN;;ADvJE;EACI,0BAAA;AC0JN;;AD3JE;EACI,0BAAA;AC8JN;;AD/JE;EACI,0BAAA;ACkKN;;ADnKE;EACI,0BAAA;ACsKN;;ADvKE;EACI,0BAAA;AC0KN;;AD3KE;EACI,0BAAA;AC8KN;;AD/KE;EACI,0BAAA;ACkLN;;ADnLE;EACI,0BAAA;ACsLN;;ADvLE;EACI,0BAAA;AC0LN;;AD3LE;EACI,0BAAA;AC8LN;;AD/LE;EACI,0BAAA;ACkMN;;ADnME;EACI,0BAAA;ACsMN;;ADvME;EACI,0BAAA;AC0MN;;AD3ME;EACI,0BAAA;AC8MN;;AD/ME;EACI,0BAAA;ACkNN;;ADnNE;EACI,0BAAA;ACsNN;;ADvNE;EACI,0BAAA;AC0NN;;AD3NE;EACI,0BAAA;AC8NN;;AD/NE;EACI,0BAAA;ACkON;;ADnOE;EACI,0BAAA;ACsON;;ADvOE;EACI,0BAAA;AC0ON;;AD3OE;EACI,0BAAA;AC8ON;;AD/OE;EACI,0BAAA;ACkPN;;ADnPE;EACI,0BAAA;ACsPN;;ADvPE;EACI,0BAAA;AC0PN;;AD3PE;EACI,0BAAA;AC8PN;;AD/PE;EACI,0BAAA;ACkQN;;ADnQE;EACI,0BAAA;ACsQN;;ADvQE;EACI,0BAAA;AC0QN;;AD3QE;EACI,0BAAA;AC8QN;;AD/QE;EACI,0BAAA;ACkRN;;ADnRE;EACI,0BAAA;ACsRN;;ADvRE;EACI,0BAAA;AC0RN;;AD3RE;EACI,0BAAA;AC8RN;;AD/RE;EACI,0BAAA;ACkSN;;ADnSE;EACI,0BAAA;ACsSN;;ADvSE;EACI,0BAAA;AC0SN;;AD3SE;EACI,0BAAA;AC8SN;;AD/SE;EACI,0BAAA;ACkTN;;ADnTE;EACI,0BAAA;ACsTN;;ADvTE;EACI,0BAAA;AC0TN;;AD3TE;EACI,0BAAA;AC8TN;;AD/TE;EACI,0BAAA;ACkUN;;ADnUE;EACI,0BAAA;ACsUN;;ADvUE;EACI,0BAAA;AC0UN;;AD3UE;EACI,0BAAA;AC8UN;;AD/UE;EACI,2BAAA;ACkVN;;AD9UA;EACE,SAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,4CAAA;EACA,oCAAA;ACiVF;;AD9UA;EACE,yBA9Ca;AC+Xf;AD/UE;EAEE,yBAnDW;ACmYf;AD7UE;EACE,qBAAA;AC+UJ;;AD3UA;EACE,eAAA;AC8UF;;AAxaA;EAEI,UAAA;EACA,WAAA;AA0aJ;;AAtaA;EACI,mBAAA;AAyaJ;;AAtaA;EAEI,iBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAwaJ;AAtaI;EACI,cAAA;EAGA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAsaR;AApaQ;EACI,yBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,oBAAA;EACA,6DAAA;EACA,kBAAA;EACA,WAAA;AAsaZ;;AAhaI;EACI,0BD7CU;ACgdlB;AAjaI;EACI,mBAAA;EACA,qBAAA;AAmaR;;AA7ZA;EACI,mBAAA;AAgaJ;;AA7ZA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAgaJ;AA9ZI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;AAgaR;AA7ZI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,2GAAA;EACA,gBAAA;EACA,YAAA;AA+ZR;AA3ZQ;EACI,sBAAA;EACA,YAAA;AA6ZZ;;AAxZA;EACI,YAAA;AA2ZJ;AAzZI;EAGI,aAAA;EAGA,kBAAA;AAuZR;AApZY;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAsZhB;AArZgB;EACI,0BDhHF;ECiHE,qBAAA;AAuZpB;AAlZQ;EAQI,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iCD5HI;EC6HJ,eAAA;EACA,aAAA;EACA,WAAA;AA6YZ;AA3YY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA6YhB;AA1YY;EACI,2CDnHE;AC+flB;AAzYY;EACI,yBDlID;ECmIC,gBAAA;EACA,iBAAA;AA2YhB;AAxYY;EACI,wBDrID;ECsIC,0BAAA;EACA,eAAA;AA0YhB;AArYY;EACI,aAAA;AAuYhB;AArYgB;EACI,uBAAA;AAuYpB;AArYoB;EACI,YAAA;AAuYxB;AAnYgB;EACI,UAAA;EACA,oBAAA;AAqYpB;AAlYgB;EACI,uBAAA;EACA,kCDvKJ;ECwKI,kBAAA;EACA,yBDlLF;ECmLE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAoYpB;AAlYoB;EACI,yBDjMN;ECkMM,2CDvKT;AC2iBf;AAhYgB;EACI,iBAAA;AAkYpB;AA7XgB;EACI,UAAA;AA+XpB;AAzXI;EACI,mBAAA;AA2XR;AA1XQ;EACI,gDAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;AA4XZ;AAvXQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,gBAAA;AAwXZ;AAvXY;EACI,eAAA;EACA,gBAAA;AAyXhB;AAtXQ;EACI,0BAAA;AAwXZ;AAvXY;EACI,0BAAA;EACA,gBAAA;EACA,YAAA;AAyXhB;AArXY;EACI,aAAA;EACA,0BAAA;EACA,yBAAA;EAEA,gBAAA;AAsXhB;AArXgB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EAEJ,eAAA;AAsXhB;AArXgB;EACI,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,cAAA;AAuXpB;AArXgB;EACI,+CAAA;AAuXpB;AArXgB;EACI,2CDtOH;ECuOG,wBDlPL;ECmPK,gBAAA;EACA,aAAA;AAuXpB;AAhXI;EACI,yBAAA;EACA,2EAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AAkXR;;AA9WA;EACI,kBAAA;AAiXJ;AAhXI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBD9QO;ACgoBf;AA/WI;EACI,gBAAA;AAiXR;AA/WQ;EACI,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAiXZ;AA/WY;EACI,kDAAA;AAiXhB;AA9WY;EACI,4BAAA;EACA,eAAA;EACA,gBAAA;AAgXhB;AA/WgB;EACI,qBAAA;AAiXpB;AA5WQ;EACI,aAAA;EACA,iBAAA;EACA,eAAA;EACA,mBDhUA;AC8qBZ;AA7WY;EACI,mBAAA;EACA,qBAAA;AA+WhB;AA9WgB;EACI,wBDrVH;ECsVG,eAAA;AAgXpB;AA7WY;EACI,SAAA;EACA,qBAAA;AA+WhB;AA9WgB;EACI,wBD7VH;EC8VG,eAAA;AAgXpB;AA3WQ;EACI,aAAA;EACA,uBAAA;AA6WZ;AA5WY;EACG,qCDnWG;ECoWH,iBAAA;EACA,0BAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACC,eAAA;AA8WhB;AA1WQ;EACI,iDAAA;AA4WZ;;AAlVI;EACI,YAAA;EACA,mBAAA;EACA,oCD3XO;EC4XP,gBAAA;EACA,8BAAA;EACA,iDAAA;EACA,aAAA;AAqVR;AAlVY;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AAoVhB;AAlVY;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AAoVhB;AAjVQ;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAmVZ;;AA1UY;EACI,UAAA;AA6UhB;AA5UgB;EACI,UAAA;AA8UpB;AAzUY;EACI,kCD9aA;ACyvBhB;AA1UgB;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBDlcH;AC8wBjB;AA3UoB;EACI,0BAAA;EACA,eAAA;AA6UxB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');\n$clr-danger-900: hsla(0, 89%, 48%, 0.19);\n$clr-danger-450: hsla(5, 99%, 64%, 1);\n$clr-danger-400: hsla(5, 100%, 69%, 1);\n$clr-danger-200: hsla(0, 48%, 83%, 1);\n$clr-primary-900: hsla(237, 69%, 40%, 1);\n$clr-primary-700: hsla(237, 69%, 52%, 1);\n$clr-primary-600: hsla(233, 100%, 57%, 1);\n$clr-primary-400: hsla(237, 40%, 67%, 1);\n$clr-primary-300: hsla(237, 46%, 75%, 1);\n$clr-light-350: hsla(0, 0%, 77%, 0.44);\n$clr-light-450: hsla(0, 0%, 85%, 1);\n$clr-light-500: hsla(0, 0%, 88%, 1);\n$clr-light-600: hsla(0, 0%, 92%, 1);\n$clr-light-700: hsla(0, 0%, 100%, 0.43);\n$clr-light-800: hsla(0, 0%, 98%, 0.83);\n$clr-light-850: hsla(0, 0%, 100%, 0.85);\n$clr-light-95: hsla(0, 0%, 95%, 1);\n$clr-light-900: hsla(0, 0%, 100%, 1);\n$clr-black: rgba(0, 0, 0, 1);\n$clr-black-900: hsla(217, 31%, 6%, 1);\n$clr-black-850: hsla(240, 50%, 4%, 0.69);\n$clr-black-500: hsla(217, 31%, 6%, 0.21);\n$clr-black-25: rgba(0, 0, 0, 0.25);\n$clr-dark-900: hsla(217, 24%, 17%, 1);\n$clr-dark-700: hsla(217, 24%, 17%, 0.788);\n$clr-dark-650: hsla(217, 24%, 17%, 0.35);\n$clr-dark-600: hsla(214, 4%, 39%, 1);\n$clr-dark-630: hsla(214, 4%, 39%, 0.63);\n$clr-dark-500: hsla(217, 1%, 50%, 1);\n$clr-dark-450: hsla(210, 1%, 50%, 1);\n$clr-dark-400: hsla(0, 0%, 97%, 0.78);\n$clr-dark-350: hsla(240, 22%, 95%, 0.22);\n$clr-link-900: hsla(240, 91%, 69%, 1);\n$clr-link-700: hsla(240, 91%, 69%, 1);\n$clr-success-400: hsla(113, 49%, 55%, 0.34);\n\n$clr-dark-300: hsla(214, 4%, 31%, 1);\n$clr-dark-250: hsla(180, 20%, 17%, 1);\n$clr-dark-200: hsla(223, 4%, 66%, 1);\n$clr-dark-150: hsla(217, 24%, 17%, 0.79);\n$clr-light-10: hsla(0, 0%, 71%, 1);\n$clr-light-15: hsla(0, 0%, 92%, 0.69);\n$clr-light-20: hsla(214, 4%, 31%, 0.8);\n$clr-light-25: hsla(0, 0%, 77%, 1);\n$clr-light-30: hsla(0, 0%, 98%, 1);\n$clr-light-35: hsla(0, 0%, 75%, 0.28);\n$clr-light-40: hsla(214, 4%, 31%, 0.79);\n$clr-primary-10: hsla(234, 95%, 92%, 0.37);\n$clr-primary-20: hsla(234, 95%, 92%, 1);\n$clr-link-600: hsla(234, 92%, 56%, 1);\n$clr-success: hsla(217, 24%, 17%, 0.93);\n$clr-table: hsla(213, 7%, 76%, 0.08);\n\n\n\n\nhtml,\nbody {\n  height: 100%;\n}\n\n@for $i from 1 through 100 {\n  $size: 1px * $i;\n\n  .font-size-#{$i} {\n      font-size: $size !important;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: 'roboto' !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: $clr-light-600 !important;\n  color: $clr-dark-900 !important;\n}\n\na {\n  color: $clr-link-700;\n\n  &:hover,\n  &:focus {\n    color: $clr-link-900;\n  }\n\n  &.no-underline {\n    text-decoration: none;\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}","@import '../../index.scss';\n\n\n#dashBody {\n\n    padding: 0;\n    border: 0px;\n\n}\n\n.HLinks:hover {\n    background: #F8F8F8;\n}\n\n.BOXXX {\n    // width: calc(100%/3);\n    background: white;\n    font-size: 16px;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    span {\n        color: #4C4F53;\n\n\n        padding: 2px 0px;\n        white-space: nowrap;\n        position: relative;\n\n        &:before {\n            background-color: #4D4DF6;\n            bottom: -11.9px;\n            content: \"\";\n            height: 2px;\n            left: 0px;\n            opacity: 0;\n            position: absolute;\n            right: 0px;\n            transform-origin: left center;\n            transform: scaleX(0);\n            transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;\n            visibility: hidden;\n            width: auto;\n        }\n    }\n}\n\n.SBOX {\n    span{\n        color: $clr-primary-600;\n    }\n    span:before {\n        visibility: visible;\n        opacity: 1 !important;\n    }\n\n\n}\n\n.selected {\n    border-radius: 18px;\n}\n\n.loader {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    font-weight: 900;\n    font-size: 24px;\n    line-height: 90px;\n\n    &__title {\n        position: absolute;\n        top: 45%;\n        left: 50%;\n        transform: translate(-45%, 0%);\n    }\n\n    .linear_progress {\n        position: absolute;\n        top: 58%;\n        left: 50%;\n        transform: translate(-50%, 0%);\n        background-image: linear-gradient(89.91deg, rgba(220, 34, 255, 0.5) 12.07%, rgba(57, 161, 244, 0.5) 89.16%);\n        margin-left: 1em;\n        width: 414px;\n        // width: calc(100% - 2em);\n        // height: 0.15em;\n\n        .MuiLinearProgress-bar {\n            background-color: #fff;\n            width: 1.5em;\n        }\n    }\n}\n\n.dashboard {\n    flex-grow: 1;\n\n    &__body {\n        // margin: 0 3rem 4rem;\n        // background-color: $clr-light-800;\n        padding: 4rem;\n        // box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);\n        // border-radius: 20px;\n        position: relative;\n\n        .setting_btn{\n            p{\n                font-size: 16px;\n                font-weight: 400;\n                margin-bottom: 0;\n                a{\n                    color: $clr-primary-600;\n                    text-decoration: none;\n                }\n            }\n        }\n\n        &__success {\n            // position: absolute;\n            // top: 9.5em;\n            // margin-top: -3rem;\n            // margin-bottom: 1rem;\n            // display: flex;\n            // justify-content: flex-start;\n            // align-items: flex-start;\n            padding: 7px 11px 9px 10px;\n            width: fit-content;\n            border-radius: 10px;\n            font-size: 12px;\n            background-color: $clr-light-600;\n            position: fixed;\n            bottom: 1.5000em;\n            left: 2.5000em;\n\n            .header__msg{\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                margin-bottom: 14px;\n            }\n\n            &.success {\n                background-color: $clr-success-400;\n            }\n\n            .success-msg {\n                color: $clr-dark-900;\n                margin-left: 1em;\n                margin-right: 1em;\n            }\n\n            .success-close {\n                color: $clr-dark-600;\n                text-decoration: underline;\n                cursor: pointer;\n            }\n        }\n\n        &__list {\n            .tab__header {\n                display: flex;\n\n                .MuiTabs-root {\n                    min-height: fit-content;\n\n                    .MuiTabs-flexContainer {\n                        height: 38px;\n                    }\n                }\n\n                .MuiButtonBase-root {\n                    padding: 0;\n                    margin-right: 0.75em;\n                }\n\n                &__item {\n                    padding: 0.6rem 1.25rem;\n                    background-color: $clr-light-900;\n                    border-radius: 4px;\n                    color: $clr-primary-300;\n                    font-size: 13px;\n                    font-weight: 700;\n                    line-height: 16px;\n                    letter-spacing: 0.25px;\n                    display: flex;\n                    min-width: 120px;\n                    justify-content: center;\n                    align-items: center;\n\n                    &.active {\n                        color: $clr-primary-900;\n                        background-color: $clr-dark-350;\n                    }\n                }\n\n                &__icon {\n                    margin-right: 5px;\n                }\n            }\n\n            .tab__body {\n                .MuiBox-root {\n                    padding: 0;\n                }\n            }\n        }\n    }\n\n    &__body__header {\n        margin-bottom: 25px;\n        .new__gate{\n            background-color: $clr-primary-600 !important;\n            border-radius: 5px;\n            box-shadow: none;\n            font-weight: 400;\n            font-size: 12px;\n            text-transform: none;\n            padding: 7px 44px;\n            font-family: 'Roboto';\n        }\n    }\n\n    &__body__header-dropdown {\n        .MuiSelectUnstyled-root{\n            color: #4C4F53;\n            font-size: 12px;\n            font-weight: 400;\n            letter-spacing: 0.25px;\n            border: 1px solid #BABCBE;\n            padding: 8px 13px;\n            border-radius: 5px;\n\n            min-width: 172px;\n            &::after{\n                font-size: 20px;\n                line-height: 0.9;\n            }\n        }\n        .MuiSelectUnstyled-root.Mui-expanded{\n            border-radius: 5px 5px 0 0;\n            &::after{\n                font-size: 28px !important;\n                line-height: 0.5;\n                float: right;\n            }\n        }\n        .MuiSelectUnstyled-popper{\n            .MuiSelectUnstyled-listbox{\n                margin-top: 0;\n                border-radius: 0 0 4px 4px;\n                border: 1px solid #BABCBE;\n                \n                min-width: 172px;\n                .MuiOptionUnstyled-root{\n                    border-radius: 0;\n                    font-size: 13px;\n                    font-weight: 400;\n                    letter-spacing: 0.25px;\n                    color: #4C4F53;\n\n                cursor: pointer;\n                &[aria-disabled=\"true\"]{\n                    pointer-events: none;\n                    user-select: none;\n                    color: #C4C4C4;\n                }\n                &:not(:last-child){\n                    border-bottom: 1px solid $clr-light-15;\n                }\n                &.Mui-selected{\n                    background-color: $clr-primary-10;\n                    color: $clr-dark-300;\n                    border-radius: 0;\n                    display: none;\n                }\n            }\n            }\n        } \n    }\n\n    &__body__header-btn {\n        background-color: #1F27AC;\n        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 3px 5px rgba(0, 0, 0, 0.2);\n        border: none;\n        text-transform: uppercase;\n        font-size: 12px;\n        letter-spacing: 0.25px;\n        padding-left: 2rem;\n        padding-right: 2rem;\n    }\n}\n\n.create__gate {\n    text-align: center;\n    &__title-text {\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 16px;\n        letter-spacing: 0.25px;\n        color: $clr-dark-300;\n    }\n\n    &__body {\n        padding-top: 1px;\n\n        .input {\n            background-color: #fff;\n            border: none;\n            width: 100%;\n            padding: 0.5em 1em;\n            border-radius: 10px;\n            font-size: 14px;\n\n            &:focus-within {\n                box-shadow: 0 0 0.05rem 0.05rem $clr-primary-300;\n            }\n\n            .MuiInput-input {\n                padding-bottom: 0 !important;\n                font-size: 14px;\n                font-weight: 400;\n                &::placeholder{\n                    opacity: 1 !important;\n                }\n            }\n        }\n\n        &__label {\n            margin: 0.5em;\n            padding-left: 1em;\n            font-size: 10px;\n            color: $clr-black;\n            &.char{\n                margin-bottom: 22px;\n                display: inline-block;\n                .error-display, &.error-display{\n                    color: $clr-danger-400;\n                    font-size: 12px;\n                }\n            }\n            &.number{\n                margin: 0;\n                display: inline-block;\n                &.error-display{\n                    color: $clr-danger-400;\n                    font-size: 12px;\n                }\n            }\n        }\n\n        &__footer {\n            display: flex;\n            justify-content: center;\n            .update__btn{\n               background-color: $clr-primary-600;\n               padding: 4px 29px;\n               text-transform: capitalize;\n               letter-spacing: 0.25px !important;\n               box-shadow: none;\n               border-radius: 5px;\n               font-weight: 600;\n                font-size: 14px;\n            }\n        }\n\n        .error {\n            box-shadow: 0 0 0.05rem 0.05rem $clr-danger-400;\n        }\n    }\n}\n\n// body:not(.custom_animation_show) {\n//     .custom_drawer_animation .MuiPaper-root {\n//         right: 100%;\n//         transition: 0.5s all\n//     }\n//     .custom_drawer_animation {\n//         background-color: transparent;\n//     }\n// }\n\n// body.custom_animation_show .custom_drawer_animation .MuiPaper-root {\n//     right: 0%;\n//     transition: 0.5s all;\n//     background: #fafafa;\n//     .MuiBox-root{\n//         z-index:2;\n//     }\n// }\n\n\n.dashboard__success__message{\n    .dashboard__body__success{\n        width: 322px;\n        word-break: inherit;\n        background-color: $clr-dark-900;\n        border-radius: 0;\n        border-left: 4px solid #00B481;\n        box-shadow: 0px 4px 4px rgba(196, 196, 196, 0.57);\n        z-index: 1400;\n\n        .header__msg{\n            .success_icon_msg{\n                font-weight: 700;\n                font-size: 12px;\n                color: #FDFDFD;\n                letter-spacing: 0.15px;\n            }\n            .success-close{\n                font-weight: 400;\n                font-size: 12px;\n                color: #FDFDFD;\n                letter-spacing: 0.15px;\n            }\n        }\n        .success-msg{\n            margin: 0;\n            font-weight: 300;\n            font-size: 12px;\n            color: #FDFDFD;\n            letter-spacing: 0.15px;\n            margin-bottom: 13px;\n            overflow: hidden;\n        }\n    }\n}\n\n\n.table__wrongUrl__container{\n    .gates__list__body-table.wrongUrl{\n        .body__header.wrongUrl{\n            .gates__list__body-table-header.wrongUrl{\n                width: 11%;\n                &:first-child{\n                    width: 50%;\n                }\n            }\n        }\n        .table__body.wrongUrl{\n            tr{\n                background-color: $clr-light-900;\n                th, a{\n                    text-align: center;\n                    font-weight: 400;\n                    font-size: 13px;\n                    color: $clr-danger-400;\n                    a{\n                        text-decoration: underline;\n                        cursor: pointer;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
